import { Outlet } from "@tanstack/react-router";
import { useAuth } from "@/lib/Auth/useAuth";
import { useOptionalUser } from "@/lib/Auth/useUser";
import { cn } from "@/lib/utils";
import { DialogProvider } from "@/lib/Components/Dialog/Providers/DialogProvider";
import { LanguageSelector } from "@/lib/i18n/LanguageSelector";
import { Toaster } from "@/components/ui/sonner";

export function NoOrganisationLayout() {
  return (
    <DialogProvider>
      <Toaster />
      <div className="flex min-h-screen">
        <div className="flex h-screen w-full flex-col overflow-y-auto bg-white md:w-[500px]">
          <div className="flex items-center justify-between p-4">
            <a href="/">
              <img
                src="/images/horizontal-logo.png"
                alt="Imoova"
                className="h-8 w-auto"
              />
            </a>
            <div className="relative">
              <LanguageSelector />
            </div>
          </div>

          <div className="flex grow justify-center p-4">
            <Outlet />
          </div>

          <UserFooter />
        </div>

        <div className="relative hidden w-0 flex-1 md:block">
          <img
            className="absolute inset-0 h-full w-full object-cover"
            src="https://images.unsplash.com/photo-1551218611-b1004ba59913?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1900&q=80"
            alt=""
          />
        </div>
      </div>
    </DialogProvider>
  );
}

function UserFooter({ className }: { className?: string }) {
  const { signOut } = useAuth();
  const user = useOptionalUser();

  if (!user) return null;

  return (
    <div
      className={cn("bg-brand flex border-t border-indigo-800 p-4", className)}
    >
      <div className="grow">
        <p className="line-clamp-2 text-left text-sm font-medium text-white">
          {user?.name ?? "--"}
        </p>
        <p className="text-left text-xs font-medium text-indigo-200 group-hover:text-white">
          {user?.email ?? "--"}
        </p>
      </div>
      <button
        onClick={() => signOut({ redirectUrl: "/sign-in" })}
        className="text-xs text-indigo-200 hover:text-white"
      >
        Sign out
      </button>
    </div>
  );
}
